import React, {ReactElement} from "react";
import {Loader} from "../../components/Loader";
import {Table} from "../../components/Table/Table";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {FormComponent} from "../../components/FormComponent";
import {RightAside} from "../../components/Aside/RightAside";
import {Link45deg, PlusCircleFill, SignTurnRightFill, XCircleFill} from "react-bootstrap-icons";
import {SysButton} from "../../components/Elements/SysButton";
import {DateTime} from "../../components/ListComponent/DateTime";
import {StatusPage} from "../StatusPage";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {TBody} from "../../components/Table/TBody";
import Select from "../../components/FormComponent/FormGroup/Select";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";

export class ProductDetails extends FormComponent {

    componentDidMount() {
        if (this.user.hasRight('product/details') === false && this.user.hasRight('product/edit') === false) {
            return;
        }

        const id: any = window.location.pathname.split('/').pop();

        this.request.fetch('/product/' + id, null, {method: 'GET'})
            .then((data: { item: { [key: string]: string }, rights: string[] } | any) => {
                if (!(data.item || null)) {
                    this.setState({
                        code: this.request.getResponseStatus() || 400,
                        message: data.message || 'unknown-error'
                    });
                    return;
                }
                this.setState(data);
            }).catch(error => {
            console.error(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent): any {
        if (data.message) {
            (
                (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
            ).innerHTML = this.dictionary.get[data.message];
        }
        (
            (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
        ).classList.remove('hide');
        RightAside.reload = true;
    }

    render() {
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }
        if (typeof this.state?.item === 'undefined') {
            return <Loader/>;
        }

        const getPNNumber = this.getPNNumber;

        let history: any = this.state.history;
        let locationHistory: any = this.state.locationHistory;

        const saveUrl = "/product/" + this.state.item.id;
        const aHistory = "/product/history#product_id=" + this.state.item.id;
        const aSnapshot = "/product/snapshot-history#product_id=" + this.state.item.id;
        const latestSnapshot = "/product/snapshot-history#snapshot_id=" + this.state?.latestLocationHistoryId;
        const startSnapshot = "/product/snapshot-history#snapshot_id=1&product_id=" + this.state.item.id;

        let allAvailable: number = 0;
        let allReserved: number = 0;
        let allQuantity: number = 0;
        let onLocationAvailable: number = 0;
        let onLocationReserved: number = 0;
        let onLocationQuantity: number = 0;
        let allHistory: number = 0;
        let allHistoryIsolated: number = 0;
        const getHistoryLink = this.getHistoryLink;
        const stateItem = this.state.item;

        return (
            <div className="x-form">

                <input type="hidden" name="id" defaultValue={this.state.item.id || ''}/>

                <div className="row gx-4">

                    {this.state.item.image_url && <>
                        <div className="col-md-12 col-lg-6 col-xl-4 details" style={{textAlign: 'center'}}
                             onClick={this.showImage}>
                            <h6 style={{textAlign: 'left'}}>{this.dictionary.get['product-image']}</h6>
                            <img alt={this.state.item.sku} src={this.state.item.image_url}
                                 style={{maxWidth: '100%', maxHeight: '240px'}}/>

                        </div>
                        <div className="hidden showImage-container" onClick={this.hideImage}>
                            &nbsp;
                        </div>
                        <div className="hidden showImage-image" onClick={this.hideImage}>
                            <img alt={this.state.item.sku} src={this.state.item.image_url}
                                 style={{maxWidth: '100%', maxHeight: '100%'}}/>
                        </div>
                    </>}

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['product-details']}
                            {this.isEditable() && <SysButton onClick={this.editDetails} type={'PencilFill'}
                                                             text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getDetails(false)}
                            </table>
                        </div>
                        {this.isEditable() && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-details"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-product-details']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable">
                                        {this.getDetails(true)}
                                    </table>
                                </div>

                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['product-properties']}
                            {this.isEditable() && <SysButton onClick={this.editProperties} type={'PencilFill'}
                                                             text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getProperties(false)}
                            </table>
                        </div>
                        {this.isEditable() && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-properties"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-product-properties']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable">
                                        {this.getProperties(true)}
                                    </table>
                                </div>

                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['product-categories']}
                            {this.isEditable() && <SysButton onClick={this.editCategories} type={'PencilFill'}
                                                             text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle">
                                {this.getCategories(false)}
                            </table>
                        </div>
                        {this.isEditable() && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-categories"
                                  className="hidden details">
                                <input type="hidden" name="product_category[]" value="0"/>
                                <h6>
                                    {this.dictionary.get['edit-product-categories']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>
                                <p style={{marginBottom: 0}}>&nbsp;</p>
                                <div className="table-responsive">
                                    <table className="table table-sm align-middle">
                                        {this.getCategories(true)}
                                    </table>
                                </div>
                                <p style={{marginBottom: 0}}>&nbsp;</p>
                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['product-quantities']}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getQuantities()}
                            </table>
                        </div>
                    </div>

                </div>
                <div className="row gx-4">
                    {this.user.hasRight('product/snapshot-history') && <div className="col-md-12 col-lg-6 details">
                        <h6>
                            {this.dictionary.get['latest-snapshot']} {this.state?.latestLocationHistoryId &&
                            <small className="text-lowercase">&nbsp;(&nbsp;
                                <a href={latestSnapshot}
                                   style={{margin: 0}}><Link45deg/>{this.dictionary.get['snapshot-history']}</a>
                                &nbsp;|&nbsp;
                                <a href={aSnapshot}
                                   style={{margin: 0}}><Link45deg/>{this.dictionary.get['product-snapshot']}</a>
                                &nbsp;)</small>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-hover table-sm align-middle">
                                <thead>
                                <tr>
                                    <th>{this.dictionary.get['location']}</th>
                                    <th>{this.dictionary.get['available_quantity']}</th>
                                    <th>{this.dictionary.get['reserved_quantity']}</th>
                                    <th>{this.dictionary.get['total_quantity']}</th>
                                    <th>{this.dictionary.get['created']}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {locationHistory.map(function (item: any) {
                                    const key = 'locationHistory' + item.location;

                                    if (item.location !== 'Damaged' && item.location !== 'Missing') {
                                        onLocationAvailable += item.available_quantity;
                                        onLocationReserved += item.reserved_quantity;
                                        onLocationQuantity += item.quantity;
                                    }

                                    allAvailable += item.available_quantity;
                                    allReserved += item.reserved_quantity;
                                    allQuantity += item.quantity;

                                    return (
                                        <tr key={key}>
                                            <td>{item.location}</td>
                                            <td>{item.available_quantity || '-'}</td>
                                            <td>{item.reserved_quantity || '-'}</td>
                                            <td>{item.quantity || '-'}</td>
                                            <td><DateTime value={item.created_at} inline={true}/></td>
                                        </tr>
                                    );
                                })}
                                <tr key="locationHistory:location-total">
                                    <th className="align-content-center">WH Location</th>
                                    <th>{onLocationAvailable || '-'}</th>
                                    <th>{onLocationReserved || '-'}</th>
                                    <th>{onLocationQuantity || '-'}</th>
                                    <th>&nbsp;</th>
                                </tr>
                                <tr key="locationHistory:location-total">
                                    <th className="align-content-center">WH TOTAL</th>
                                    <th>{allAvailable || '-'}</th>
                                    <th>{allReserved || '-'}</th>
                                    <th>{allQuantity || '-'}</th>
                                    <th>&nbsp;</th>
                                </tr>
                                <tr key="locationHistory:bc:provider_sales_quantity" className="lastLine">
                                    <td className="align-content-center">BC Sales</td>
                                    <td>{this.state.item.provider_sales_quantity || '-'}</td>
                                    <td>-</td>
                                    <td>{this.state.item.provider_sales_quantity || '-'}</td>
                                    <td><DateTime value={this.state.item.imported_at} inline={true}/></td>
                                </tr>
                                <tr key="locationHistory:bc:provider_marketing_quantity" className="lastLine">
                                    <td className="align-content-center">BC Marketing</td>
                                    <td>{this.state.item.provider_marketing_quantity || '-'}</td>
                                    <td>-</td>
                                    <td>{this.state.item.provider_marketing_quantity || '-'}</td>
                                    <td><DateTime value={this.state.item.imported_at} inline={true}/></td>
                                </tr>
                                <tr key="locationHistory:bc:provider_missing_quantity" className="lastLine">
                                    <td className="align-content-center">BC Missing</td>
                                    <td>{this.state.item.provider_missing_quantity || '-'}</td>
                                    <td>-</td>
                                    <td>{this.state.item.provider_missing_quantity || '-'}</td>
                                    <td><DateTime value={this.state.item.imported_at} inline={true}/></td>
                                </tr>
                                <tr key="locationHistory:bc:damaged_quantity" className="lastLine">
                                    <td className="align-content-center">BC Damaged</td>
                                    <td>{this.state.item.provider_damaged_quantity || '-'}</td>
                                    <td>-</td>
                                    <td>{this.state.item.provider_damaged_quantity || '-'}</td>
                                    <td><DateTime value={this.state.item.imported_at} inline={true}/></td>
                                </tr>
                                <tr key="locationHistory:bc:provider_mainhu_quantity" className="lastLine">
                                    <td className="align-content-center">BC MainHU</td>
                                    <td>{this.state.item.provider_mainhu_quantity || '-'}</td>
                                    <td>-</td>
                                    <td>{this.state.item.provider_mainhu_quantity || '-'}</td>
                                    <td><DateTime value={this.state.item.imported_at} inline={true}/></td>
                                </tr>
                                <tr key="locationHistory:bc:provider_zmainhu_quantity" className="lastLine">
                                    <td className="align-content-center">BC ZMainHU</td>
                                    <td>{this.state.item.provider_zmainhu_quantity || '-'}</td>
                                    <td>-</td>
                                    <td>{this.state.item.provider_zmainhu_quantity || '-'}</td>
                                    <td><DateTime value={this.state.item.imported_at} inline={true}/></td>
                                </tr>
                                <tr key="locationHistory:bc" className="lastLine">
                                    <td className="align-content-center">BC Inventory</td>
                                    <td>{this.state.item.provider_quantity || '-'}</td>
                                    <td>-</td>
                                    <td>{this.state.item.provider_quantity || '-'}</td>
                                    <td><DateTime value={this.state.item.imported_at} inline={true}/></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {this.user.hasRight('product/history') && <div className="col-md-12 col-lg-6 details">
                        <h6>
                            {this.dictionary.get['product-history']}
                            <small className="text-lowercase">
                                <a href={aHistory}><Link45deg/>{this.dictionary.get['show-all']}</a>
                            </small>
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-hover table-sm align-middle">
                                <thead>
                                <tr>
                                    <th>{this.dictionary.get['type']}</th>
                                    <th>{this.dictionary.get['quantity']}</th>
                                    <th>{this.dictionary.get['isolated_quantity']}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr key="history:first" className="lastLine">
                                    <td className="align-content-center">
                                        {Util.link('start', startSnapshot)}
                                    </td>
                                    <td align="right">{this.state.startCount || '-'}</td>
                                    <td>&nbsp;</td>
                                </tr>
                                {history.map(function (item: any) {
                                    const key = 'history:' + item.type;
                                    allHistory += parseInt(item.quantity || 0);
                                    allHistoryIsolated += parseInt(item.isolated_quantity || 0);
                                    return (
                                        <tr key={key}>
                                            <td>{getHistoryLink(item.type.toLocaleLowerCase(), stateItem)}</td>
                                            <td align="right">{getPNNumber(item.quantity)}</td>
                                            <td align="right">{getPNNumber(item.isolated_quantity)}</td>
                                        </tr>
                                    );
                                })}
                                <tr key="history:last">
                                    <th className="align-content-center">SUM</th>
                                    <th align="right">{this.state.startCount + allHistory}</th>
                                    <th align="right">{allHistoryIsolated}</th>
                                </tr>
                                <tr key="history:total" className="lastLine">
                                    <th className="align-content-center">TOTAL</th>
                                    <th align="right">{this.state.startCount + allHistory + allHistoryIsolated}</th>
                                    <td align="right">&nbsp;</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }

    private getPNNumber(num: any): any {
        if (parseInt(num) === 0 || isNaN(parseInt(num))) {
            return '0';
        }
        if (parseInt(num) < 0) {
            return parseInt(num);
        }
        return '+' + parseInt(num);
    }

    private getStatus(input: boolean, status: any): ReactElement {
        if (!input) {
            return status;
        }
        return (
            <FormGroup.Select {...{
                id: 'status',
                skipLabel: true,
                basic: 'please-select',
                items: ['active', 'inactive'],
                defaultValue: status
            }}/>
        );
    }

    private getType(input: boolean, type: any): ReactElement {
        if (!input) {
            return type;
        }
        return (
            <FormGroup.Select {...{
                id: 'type',
                skipLabel: true,
                basic: 'please-select',
                items: ['product', 'virtual-product', 'packaging-material', 'flyer', 'bundle', 'pack', 'alias', 'service', 'carton'],
                defaultValue: type
            }}/>
        );
    }

    private getInput(input: boolean, id: string, value: any, copy: boolean = false): ReactElement {
        if (!input) {
            return copy ? Util.copyCell(value) : value;
        }
        return (
            <FormGroup.Input {...{skipLabel: true, id: id, defaultValue: value}}/>
        );
    }

    private getDetails(input: boolean): ReactElement {
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['id'], Util.copyCell(this.state.item.id || '')],
                    [this.dictionary.get['sku'], Util.copyCell(this.state.item.sku)],
                    [this.dictionary.get['barcode'], this.getInput(input, 'barcode', this.state.item.barcode || '', true)],
                    [this.dictionary.get['name'], this.getInput(input, 'name', this.state.item.name || '', true)],
                    [this.dictionary.get['tariff_no'], this.getInput(input, 'tariff_no', this.state.item.tariff_no || '', true)],
                    [this.dictionary.get['status'], this.getStatus(input, this.state.item.status)],
                    [this.dictionary.get['type'], this.getType(input, this.state.item.type)]
                ]
            }}/>
        );
    }

    private getQuantities(): ReactElement {
        return (
            <Table.TBody {...{
                data: [
                    ['', this.dictionary.get['hub']],
                    [this.dictionary.get['quantity'], FormattedNumber.format(this.state.item.quantity || '')],
                    [this.dictionary.get['isolated_quantity'], FormattedNumber.format(this.state.item.isolated_quantity || '')],
                    [this.dictionary.get['transfer_in_quantity'], FormattedNumber.format(this.state.item.transfer_in_quantity || '')],

                    ['', this.dictionary.get['provider']],
                    [this.dictionary.get['provider_sales_quantity'], FormattedNumber.format(this.state.item.provider_sales_quantity || '')],
                    [this.dictionary.get['provider_marketing_quantity'], FormattedNumber.format(this.state.item.provider_marketing_quantity || '')],
                    [this.dictionary.get['provider_mainhu_quantity'], FormattedNumber.format(this.state.item.provider_mainhu_quantity || '')],
                    [this.dictionary.get['provider_zmainhu_quantity'], FormattedNumber.format(this.state.item.provider_zmainhu_quantity || '')],
                    [this.dictionary.get['provider_quantity'], FormattedNumber.format(this.state.item.provider_quantity || '')],

                    ['', this.dictionary.get['warehouse']],

                    [this.dictionary.get['warehouse_quantity'], FormattedNumber.format(this.state.item.warehouse_quantity || '')],
                    [this.dictionary.get['warehouse_available_quantity'], FormattedNumber.format(this.state.item.warehouse_available_quantity || '')],
                    [this.dictionary.get['warehouse_reserved_quantity'], FormattedNumber.format(this.state.item.warehouse_reserved_quantity || '')],

                    ['', this.dictionary.get['missing_quantity']],
                    [this.dictionary.get['hub'], FormattedNumber.format(this.state.item.missing_quantity || '')],
                    [this.dictionary.get['warehouse'], FormattedNumber.format(this.state.item.warehouse_missing_quantity || '')],
                    [this.dictionary.get['provider'], FormattedNumber.format(this.state.item.provider_missing_quantity || '')],

                    ['', this.dictionary.get['damaged_quantity']],
                    [this.dictionary.get['hub'], FormattedNumber.format(this.state.item.damaged_quantity || '')],
                    [this.dictionary.get['warehouse'], FormattedNumber.format(this.state.item.warehouse_damaged_quantity || '')],
                    [this.dictionary.get['provider'], FormattedNumber.format(this.state.item.provider_damaged_quantity || '')],
                ]
            }}/>
        );
    }

    private getProperties(input: boolean): ReactElement {
        if (input) {
            return (
                <Table.TBody {...{
                    data: [
                        [this.dictionary.get['unit_cost'], this.getInput(true, 'unit_cost', this.state.item.unit_cost || ''), 'EUR'],
                        [this.dictionary.get['width'], this.getInput(true, 'width', this.state.item.width || ''), 'cm'],
                        [this.dictionary.get['height'], this.getInput(true, 'height', this.state.item.height || ''), 'cm'],
                        [this.dictionary.get['length'], this.getInput(true, 'length', this.state.item.length || ''), 'cm'],
                        [this.dictionary.get['volume'], this.getInput(true, 'volume', this.state.item.volume || ''), 'cm3'],
                        [this.dictionary.get['weight'], this.getInput(true, 'weight', this.state.item.weight || ''), 'kg'],
                    ]
                }}/>
            );
        }
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['unit_cost'], this.state.item.unit_cost ? this.state.item.unit_cost + ' EUR' : '-'],
                    [this.dictionary.get['width'], this.state.item.width ? this.state.item.width + ' cm' : '-'],
                    [this.dictionary.get['height'], this.state.item.height ? this.state.item.height + ' cm' : '-'],
                    [this.dictionary.get['length'], this.state.item.length ? this.state.item.length + ' cm' : '-'],
                    [this.dictionary.get['volume'], this.state.item.volume ? this.state.item.volume + ' cm3' : '-'],
                    [this.dictionary.get['weight'], this.state.item.weight ? this.state.item.weight + ' kg' : '-'],
                    [this.dictionary.get['carton-contains'], this.state.item.product_pack_quantity ? this.state.item.product_pack_quantity + ' ' + this.dictionary.get['pc'] : '-'],
                    [this.dictionary.get['created_at'], DateTime.create({
                        value: this.state.item.created_at,
                        inline: true
                    })],
                ]
            }}/>
        );
    }

    private getCategories(input: boolean): ReactElement {
        if (input) {
            return this.getCategoriesEdit();
        }
        let categories = [
            ['ID', this.dictionary.get['name'], this.dictionary.get['code']]
        ];
        for (var i in this.state.productCategories) {
            categories.push([
                this.state.productCategories[i].id,
                this.state.productCategories[i].name,
                this.state.productCategories[i].code
            ]);
        }
        return (
            <Table.TBody {...{data: categories}}/>
        );
    }

    private removeCategory(e: any): void {
        e.preventDefault();
        const tr = e.target.closest('tr');
        if (tr) {
            tr.remove();
        }
    }

    private addCategory(e: any): void {
        e.preventDefault();
        const tr = e.target.closest('tr');
        if (!tr) {
            console.error('Can not find closest tr element.')
            return;
        }

        const select: HTMLSelectElement = tr.querySelector('select');
        const categoryId = select.value;

        if (categoryId === "0" || categoryId === "") {
            return;
        }

        let newLine: HTMLElement = document.createElement("tr"),
            input: HTMLElement = document.createElement("input"),
            col1: HTMLElement = document.createElement("td"),
            col2: HTMLElement = document.createElement("td"),
            col3: HTMLElement = document.createElement("td");

        // <input type="hidden" name="product_category[]" value={item.id}/>
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'product_category[]');
        input.setAttribute('value', categoryId);

        newLine.append(col1, col2, col3);

        col1.textContent = categoryId;
        col1.append(input);
        col2.textContent = select.options[select.selectedIndex].text;
        col2.setAttribute("colspan", "2");
        col3.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" class="bi bi-x-circle-fill removeIcon"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"></path></svg>';

        let parent = tr.parentNode;

        parent.insertBefore(newLine, tr);

        (col3.children[0] as HTMLElement).addEventListener("click", function (e: any) {
            e.preventDefault();
            const tr = e.target.closest('tr');
            if (tr) {
                tr.remove();
            }
        });

        select.selectedIndex = 0;
    }

    private getCategoriesEdit(): ReactElement {
        this.state.categories[0] = this.dictionary.get['please-select'];
        return (
            <tbody key={'rowI' + (++TBody.index)}>
            {this.state.productCategories.map((item: any) => {
                return (
                    <tr key={'rowI' + TBody.index++}>
                        <td>{item.id}<input type="hidden" name="product_category[]" value={item.id}/></td>
                        <td>{item.name}</td>
                        <td>{item.code}</td>
                        <td><XCircleFill onClick={this.removeCategory} className="removeIcon"/></td>
                    </tr>
                )
            })}
            <tr key={'rowI' + TBody.index++} className="newItem">
                <td colSpan={3}><Select skipLabel={true} items={this.state.categories} skipTranslate={true}/></td>
                <td><PlusCircleFill onClick={this.addCategory} className="addIcon"/></td>
            </tr>
            </tbody>
        );
    }

    private editProperties(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-properties') as HTMLElement);
    }

    private editDetails(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-details') as HTMLElement);
    }

    private editCategories(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-categories') as HTMLElement);
    }


    private isEditable(onlyRights: boolean = false): boolean {
        if (this.user.hasRight('product/edit') === false) {
            return false;
        }
        if (onlyRights) {
            return true;
        }
        return true;
    }

    private showImage(e: any) {
        e.preventDefault();
        const container = document.querySelector('.showImage-container') as HTMLElement;
        if (container.classList.contains('hidden')) {
            container.classList.remove('hidden');
        }
        const imageHolder = document.querySelector('.showImage-image') as HTMLElement;
        if (imageHolder.classList.contains('hidden')) {
            imageHolder.classList.remove('hidden');
        }
    }

    private hideImage(e: any) {
        e.preventDefault();
        const container = document.querySelector('.showImage-container') as HTMLElement;
        if (!container.classList.contains('hidden')) {
            container.classList.add('hidden');
        }
        const imageHolder = document.querySelector('.showImage-image') as HTMLElement;
        if (!imageHolder.classList.contains('hidden')) {
            imageHolder.classList.add('hidden');
        }
    }

    private getHistoryLink(name: string, item: any): string | any {
        if (name === 'b2c-order') {
            return Util.link(name, '/order/list#sku=' + item.sku + '&type=B2C');
        }
        if (name === 'b2b-order') {
            return Util.link(name, '/order/list#sku=' + item.sku + '&type=B2B');
        }
        if (name === 'shipment') {
            return Util.link(name, '/shipment/list#sku=' + item.sku);
        }
        if (name === 'receipt') {
            return Util.link(name, '/receipt/list#sku=' + item.sku);
        }
        if (name.includes('transfer') || name.includes('inventory') || name === 'transfer' || name === 'transfer-in' || name === 'transfer-out') {
            return Util.link(name, '/transfer-product/list#sku=' + item.sku);
        }
        return name;
    }
}
